import React, { useState } from 'react';

import { Check, CopyIcon, ExternalLink, UnplugIcon } from 'lucide-react';

import ChainIcon from '@/components/ChainIcon';
import { Button } from '@/components/shadcn/ui/button';
import { Collapsible, CollapsibleTrigger } from '@/components/shadcn/ui/collapsible';
import { useCoinwebWallet } from '@/networks/coinweb';
import { cn, truncateMidAddressInputValue } from '@/utils';

const HeaderWalletDrawerCwebWalletDetails: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const { address, disconnect } = useCoinwebWallet();

  const handleCopyAddress = (e: React.MouseEvent) => {
    e.stopPropagation();
    void navigator.clipboard.writeText(address || '');
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 300);
  };

  return (
    <Collapsible
      open={isExpanded}
      onOpenChange={setIsExpanded}
      className="bg-background/60 hover:bg-background/80 flex w-full flex-col justify-between gap-2 overflow-hidden
        rounded-xl p-2.5 text-sm text-gray-400 sm:px-2.5 md:px-4"
    >
      <CollapsibleTrigger className={cn('flex w-full cursor-pointer items-center justify-between gap-1')} asChild>
        <div className="flex w-full items-center justify-start text-left">
          <div className="bg-background relative mr-2 shrink-0 rounded-full p-1">
            <ChainIcon src={'/chains/coinweb.svg'} className="size-8" />
          </div>
          <div className="text-primary-foreground w-full overflow-hidden text-lg font-semibold">
            {truncateMidAddressInputValue(address || '', 16)}
          </div>
          <div className="flex gap-2">
            <Button
              variant="secondary"
              className="bg-foreground h-auto rounded-xl p-2 leading-2"
              onClick={handleCopyAddress}
            >
              {isCopied ? <Check className="size-4" color="green" /> : <CopyIcon className="size-4" />}
            </Button>

            <Button
              variant="secondary"
              className="bg-foreground h-auto rounded-xl p-2 leading-2"
              onClick={(e) => {
                e.stopPropagation();
                window.open(import.meta.env.VITE_EXPLORER_URL, '_blank', 'noopener,noreferrer');
              }}
            >
              <ExternalLink className="size-4" />
            </Button>

            <Button
              variant="secondary"
              className="bg-foreground h-auto rounded-xl p-2 leading-2"
              onClick={(e) => {
                e.stopPropagation();
                disconnect();
              }}
            >
              <UnplugIcon className="size-4" />
            </Button>
          </div>
        </div>
      </CollapsibleTrigger>
    </Collapsible>
  );
};

export default HeaderWalletDrawerCwebWalletDetails;
